module.exports = __webpack_public_path__ + "media/images/logo_fhye-8d25e2b4.png";